module.exports = __webpack_public_path__ + "img/qu_ar.3a0f1c4.jpg";